import {
  Directive,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { ReleaseFeatureFlagToggles } from '../interface/feature-flags.interface';
import { TogglesFacade } from '../state/toggles/toggles.facade';

@Directive({
  selector: '[schuecoFeatureFlagActive]',
})
export class FeatureFlagActiveDirective implements OnInit, OnChanges, OnDestroy {
  @Input() schuecoFeatureFlagActive?: ReleaseFeatureFlagToggles;
  @Input() schuecoFeatureFlagActiveElse?: TemplateRef<any>;

  private readonly togglesFacade = inject(TogglesFacade);
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  private unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.initializeSubscription();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['schuecoFeatureFlagActive'] || changes['schuecoFeatureFlagActiveElse']) {
      this.unsubscribe$.next();
      this.initializeSubscription();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initializeSubscription() {
    if (this.schuecoFeatureFlagActive) {
      this.togglesFacade
        .flag(this.schuecoFeatureFlagActive)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((status: boolean | undefined) => {
          this.viewContainer.clear();

          if (status) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else if (this.schuecoFeatureFlagActiveElse) {
            this.viewContainer.createEmbeddedView(this.schuecoFeatureFlagActiveElse);
          }
        });
    }
  }
}
